import { render, staticRenderFns } from "./CustomDetailsForm.vue?vue&type=template&id=8f46f87e"
import script from "./CustomDetailsForm.vue?vue&type=script&lang=ts"
export * from "./CustomDetailsForm.vue?vue&type=script&lang=ts"
import style0 from "./CustomDetailsForm.vue?vue&type=style&index=0&id=8f46f87e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports